import {
	apiClient,
	getAuthHeaders,
	handleServiceError,
} from 'api/config/config';

// Reward Services
export const rewardService = {
	// --- CRUD --- //
	getAll: async (token) => {
		try {
			return await apiClient.post(
				'client/api/v1/reward/list',
				{ options: { sort: { createdAt: -1 } } },
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	claim: async (token, stepKey) => {
		try {
			return await apiClient.post(
				'/client/api/v1/reward/claim',
				{ stepKey },
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
};
